import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable ,  Subject } from "rxjs";
import { CommsService } from "../services/comms.service";
import { SessionStatus } from "../components/models/SessionStatus";
import { SessionType } from "../components/models/SessionType";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private commsService: CommsService) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.isUserSessionAuthenticated(state.url.toLowerCase());
    }

    isUserSessionAuthenticated(url: string): Observable<boolean> {
        var subject = new Subject<boolean>();
        var videoPath = '/video';
        var audioPath = '/audio';
        var imPath = '/im';

        this.commsService.validateSession()
            .subscribe((returnValue) => {
                switch (returnValue) {
                    case SessionStatus.notFound:
                    case SessionStatus.notStarted:
                    case SessionStatus.ended:
                        this.router.navigateByUrl('/');
                        subject.next(false);
                        break;
                    case SessionStatus.started:
                        //get session details
                        this.commsService.sessionInfo().subscribe(
                            (result) => {
                                this.commsService.activeSessionInfo = result;
                                switch (result.sessionType) {
                                    case SessionType.video:
                                        if (url != videoPath)
                                            this.router.navigateByUrl(videoPath);
                                        break;
                                    case SessionType.audio:
                                        if (url != audioPath)
                                            this.router.navigateByUrl(audioPath);
                                        break;
                                    case SessionType.im:
                                        if (url != imPath)
                                            this.router.navigateByUrl(imPath);
                                        break;
                                }
                                subject.next(true);
                            },
                            (error) => {
                                this.router.navigateByUrl('/');
                                subject.next(false);
                            }
                        );
                        break;
                }
            },
            (error) => {
                this.router.navigateByUrl('/');
                subject.next(false);
            });

        return subject.asObservable();
    }

}
